import { Button } from "primereact/button";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../shared/CommonFunctions";
import FormDirtyListener from "../formListener/FormDirtyListener";

export interface ComponentHeaderProps {
  dateCreated?: string;
  userCreated?: string;
  editPath?: string;
  showEdit?: boolean;
  backPath?: string;
  showBack?: boolean;
  label?: string;
}

export default function ComponentHeader({
  dateCreated,
  userCreated,
  editPath,
  showEdit = false,
  backPath,
  showBack = false,
  label,
}: ComponentHeaderProps) {
  const navigate = useNavigate();

  const [isDirty, setIsDirty] = useState(false);

  return (
    <>
      {showBack && backPath && <FormDirtyListener onDirtyChange={setIsDirty} />}
      <div className="w-full border-0 shadow-none comp-header">
        <div className="flex justify-content-between align-items-center w-full mb-3 border-purple border-2 text-purple font-bold flex-wrap header-height">
          <div>
            <h4 className="text-purple flex align-items-center">
              <span className="pl-1 mx-1 mt-0"></span>
              <span>{label}</span>
            </h4>
          </div>
          <div>
            {userCreated != null && (
              <>
                <span className="user-icon ml-3 pr-2"></span> <span> {userCreated}</span>
                <span className="time-stamp pr-2"></span> <span>{formatDate(dateCreated!)}</span>
              </>
            )}
          </div>
          <div className="dont-show-in-print ">
            {showEdit && editPath && (
              <Button onClick={() => navigate(editPath ?? "")} label="Edit" className="bg-transparent border-none text-purple mr-2 edit-icon" />
            )}{" "}
            {showBack && backPath && (
              <Button
                id="backBtn"
                onClick={() => {
                  if (!isDirty) {
                    navigate(backPath);
                  }
                }}
                label="Back"
                className="bg-transparent border-none text-purple mr-2 back-icon"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
